import {useState} from "react";

// Components


// Scss
import '../assets/css/partnerPortal/homepage.scss';
import '../assets/css/partnerPortal/welcome.scss';

// Images
import chevronDown from '../assets/img/partnerPortal/welcomePage/chevron-down.png';
import chevronUp from '../assets/img/partnerPortal/welcomePage/chevron-up.png';


function ButtonOne(props) {


  const text = props.text;
  const [link] = useState(props.link);
  const [className] = useState(props.className);
  const [classNameOfA] = useState(props.classNameOfA);
  const [withoutIcon] = useState(props.withoutIcon);
  const [target] = useState(props.target);
  const action = props.action;

  function getButton() {
    if(action) {
        return <div className={"buttonDown mt-2 buttonHover " + className} onClick={action}>   
                    <div className="buttonLetters lettersChange" >
                        {text}
                        {withoutIcon ? "" : text === "Show more " ? <img src={chevronDown} alt='...'  /> : <img src={chevronUp} alt='...'  />}
                    </div>
                </div>;
    }

    return <a href={link} target={target ? target : "_parent"} className={classNameOfA + " d-flex justify-content-center"} >
                <div className={"buttonSignUp mt-2 buttonHover " + className}>  
                    <div className="buttonLetters" onClick={action}>
                        {text}
                        {withoutIcon ? "" : <img src={chevronDown} alt='...'  />}
                    </div>
                </div>
            </a>;
  }

  return (
    <>
        {/* <div className={"buttonSignUp mt-2 buttonHover " + className}>     */}
            {getButton()}
        {/* </div> */}
            
    </>
  );


}

export default ButtonOne;

